"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.accountEmailStatusesSchema = exports.accountEmailRequestBodySchema = exports.accountEmailResultSchema = exports.updateEmailSettingsBodySchema = exports.emailSettingsSchema = exports.emailTestSendSchema = exports.emailPreviewSchema = exports.updateEmailTemplateBodySchema = exports.emailTemplatesSchema = exports.emailTemplateSchema = exports.emailTemplateKindParamsSchema = exports.emailOutcomeSchema = exports.ACCOUNT_EMAIL_STATUSES = exports.accountEmailKindSchema = exports.ACCOUNT_EMAIL_KINDS = void 0;
// J-408 (Louis, 2026-11-02 1:00 PM ET, steps 1 to 4): wire shapes of the account emails, served under `/api/v1`.
// No field carries PHI, and none carries a password except `temporaryPassword` on the one answer whose email could
// not be sent (Louis: "if the mail cannot be sent, the screen shows it once as today and says the email failed").
const zod_1 = require("zod");
/** The three emails, as stored. */
exports.ACCOUNT_EMAIL_KINDS = [
    "account_created",
    "password_reset",
    "forgot_password",
];
exports.accountEmailKindSchema = zod_1.z.enum(exports.ACCOUNT_EMAIL_KINDS);
/** A queued email's stored states. */
exports.ACCOUNT_EMAIL_STATUSES = ["queued", "sent", "failed"];
/** What the admin screen says of an email: Louis's words, emailed, queued or failed. */
exports.emailOutcomeSchema = zod_1.z.enum(["emailed", "queued", "failed"]);
exports.emailTemplateKindParamsSchema = zod_1.z.object({ kind: exports.accountEmailKindSchema });
exports.emailTemplateSchema = zod_1.z
    .object({
    kind: exports.accountEmailKindSchema,
    subject: zod_1.z.string(),
    body: zod_1.z.string(),
    /** True while no admin edit is stored: the default text is in use. */
    isDefault: zod_1.z.boolean(),
    updatedAt: zod_1.z.string().nullable(),
    /** The fill-ins this email can fill, and the ones saving refuses to drop. */
    fillIns: zod_1.z.array(zod_1.z.string()),
    required: zod_1.z.array(zod_1.z.string()),
})
    .meta({ id: "EmailTemplate" });
exports.emailTemplatesSchema = zod_1.z
    .object({ templates: zod_1.z.array(exports.emailTemplateSchema) })
    .meta({ id: "EmailTemplates" });
exports.updateEmailTemplateBodySchema = zod_1.z.strictObject({
    subject: zod_1.z.string().trim().min(1).max(200),
    body: zod_1.z.string().min(1).max(10_000),
});
/** The preview with sample values (a draft that is not saved yet may be previewed). */
exports.emailPreviewSchema = zod_1.z
    .object({ subject: zod_1.z.string(), text: zod_1.z.string(), html: zod_1.z.string() })
    .meta({ id: "EmailPreview" });
exports.emailTestSendSchema = zod_1.z
    .object({ outcome: exports.emailOutcomeSchema, to: zod_1.z.literal("you") })
    .meta({ id: "EmailTestSend" });
exports.emailSettingsSchema = zod_1.z
    .object({
    /** Null: the transport's own sender (the Azure-managed domain's in Azure, MAIL_FROM). */
    senderAddress: zod_1.z.string().nullable(),
    /** The address mail goes out from now. */
    effectiveSender: zod_1.z.string(),
    replyTo: zod_1.z.string().nullable(),
    temporaryPasswordHours: zod_1.z.number().int(),
    /** none, smtp or acs: where mail goes. */
    transport: zod_1.z.string(),
    updatedAt: zod_1.z.string().nullable(),
})
    .meta({ id: "EmailSettings" });
exports.updateEmailSettingsBodySchema = zod_1.z.strictObject({
    senderAddress: zod_1.z.email().max(254).nullable(),
    replyTo: zod_1.z.email().max(254).nullable(),
    temporaryPasswordHours: zod_1.z.number().int().min(0).max(720),
});
/** An email asked for on an account: what happened at once, and the password only when it could not be sent. */
exports.accountEmailResultSchema = zod_1.z
    .object({
    userId: zod_1.z.string(),
    kind: exports.accountEmailKindSchema,
    outcome: exports.emailOutcomeSchema,
    temporaryPassword: zod_1.z.string().optional(),
})
    .meta({ id: "AccountEmailResult" });
exports.accountEmailRequestBodySchema = zod_1.z.strictObject({
    kind: zod_1.z.enum(["account_created", "password_reset"]),
});
/** Each account's latest temporary-password email, for the Users & Access rows. */
exports.accountEmailStatusesSchema = zod_1.z
    .object({
    statuses: zod_1.z.array(zod_1.z.object({
        userId: zod_1.z.string(),
        kind: exports.accountEmailKindSchema,
        outcome: exports.emailOutcomeSchema,
        requestedAt: zod_1.z.string(),
    })),
})
    .meta({ id: "AccountEmailStatuses" });
//# sourceMappingURL=account-email.js.map